"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MetaDependencyEventHandler", {
    enumerable: true,
    get: function() {
        return MetaDependencyEventHandler;
    }
});
const _common = require("@nestjs/common");
const _types = require("./types");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let MetaDependencyEventHandler = class MetaDependencyEventHandler {
    registerEvents(metaEventHandler) {
        for (const each of metaEventHandler){
            for (const eachType of each.triggerMetaEvents){
                var _this_metaEventHandlerMap_eachType;
                this.metaEventHandlerMap[eachType] = (_this_metaEventHandlerMap_eachType = this.metaEventHandlerMap[eachType]) != null ? _this_metaEventHandlerMap_eachType : [];
                this.metaEventHandlerMap[eachType].push(each);
            }
        }
    }
    async handleEvent(context, param, ncMeta = _Noco.default.ncMeta) {
        // if suppressed, do not make further evaluation
        if (context.suppressDependencyEvaluation) {
            return;
        }
        // next context will have suppressDependencyEvaluation as true by default unless modules override it.
        const nextContext = _extends({}, context, {
            suppressDependencyEvaluation: true
        });
        let trxNcMeta;
        try {
            var _this_metaEventHandlerMap_param_eventType;
            for (const handler of (_this_metaEventHandlerMap_param_eventType = this.metaEventHandlerMap[param.eventType]) != null ? _this_metaEventHandlerMap_param_eventType : []){
                const affectedDependencies = await handler.getAffectedDependency(nextContext, param, trxNcMeta != null ? trxNcMeta : ncMeta);
                if (affectedDependencies) {
                    trxNcMeta = trxNcMeta != null ? trxNcMeta : await ncMeta.startTransaction();
                    await handler.handle(nextContext, _extends({}, param, {
                        affectedDependencyResult: affectedDependencies
                    }), trxNcMeta);
                }
            }
            await (trxNcMeta == null ? void 0 : trxNcMeta.commit());
        } catch (ex) {
            await (trxNcMeta == null ? void 0 : trxNcMeta.rollback());
            throw ex;
        }
    }
    constructor(metaEventHandlers){
        this.metaEventHandlers = metaEventHandlers;
        this.metaEventHandlerMap = {
            COLUMN_ADDED: [],
            COLUMN_DELETED: [],
            COLUMN_UPDATED: []
        };
        this.registerEvents(metaEventHandlers);
    }
};
MetaDependencyEventHandler = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)(_types.META_DEPENDENCY_MODULE_PROVIDER_KEY)),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Array
    ])
], MetaDependencyEventHandler);
